import React from 'react'
import styled from 'styled-components'

import GrainImage from '../assets/textures/grain.png'

const Grain = () => {
  return <Wrapper className="grain" />
}

const Wrapper = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(${GrainImage});

  @media only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (min--moz-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 200dpi),
    only screen and (min-resolution: 2dppx) {
    background-size: 15rem;
  }
`

export default Grain
